<template>
<div class="content">
  <div>
    <el-select size="mini" v-model="group_id" clearable filterable placeholder="选择职位" @change="getList()">
      <el-option
        v-for="item in tableData.group_list"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
  </div>
  <el-row :gutter="5">
    <el-col :span="12">
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item label="催费登记前10名">
          <template slot="label">
            <span class="label-title">催费登记前10名</span>
          </template>
          <el-table
            :data="tableData.list1"
            :loading="loading"
            :row-class-name="rowClass"
            style="width: 100%">
            <el-table-column
              prop="战区名称"
              label="战区名称"
              width="100">
            </el-table-column>
            <el-table-column
              prop="片区名称"
              label="片区名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="项目名称"
              label="项目名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="职位"
              label="职位"
              width="100">
            </el-table-column>
            <el-table-column
              prop="管家名称"
              label="催费人员"
              width="100">
            </el-table-column>
            <el-table-column
              prop="催费户数"
              label="催费户数">
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </el-col>
    <el-col :span="12">
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item label="催费登记后10名">
          <template slot="label">
            <span class="label-title">催费登记后10名</span>
          </template>
          <el-table
            :data="tableData.list2"
            :loading="loading"
            :row-class-name="rowClass"
            style="width: 100%">
            <el-table-column
              prop="战区名称"
              label="战区名称"
              width="100">
            </el-table-column>
            <el-table-column
              prop="片区名称"
              label="片区名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="项目名称"
              label="项目名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="职位"
              label="职位"
              width="100">
            </el-table-column>
            <el-table-column
              prop="管家名称"
              label="催费人员"
              width="120">
            </el-table-column>
            <el-table-column
              prop="催费户数"
              label="催费户数">
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </el-col>
  </el-row>
  <el-row :gutter="5">
    <el-col :span="12">
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item label="催费回款金额前10名">
          <template slot="label">
            <span class="label-title">催费回款金额前10名</span>
          </template>
          <el-table
            :data="tableData.list3"
            :loading="loading"
            :row-class-name="rowClass"
            style="width: 100%">
            <el-table-column
              prop="战区名称"
              label="战区名称"
              width="100">
            </el-table-column>
            <el-table-column
              prop="片区名称"
              label="片区名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="项目名称"
              label="项目名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="职位"
              label="职位"
              width="100">
            </el-table-column>
            <el-table-column
              prop="管家名称"
              label="催费人员"
              width="120">
            </el-table-column>
            <el-table-column
              prop="催费金额"
              label="催费金额(元)">
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </el-col>
    <el-col :span="12">
      <el-descriptions direction="vertical" :column="1" border>
        <el-descriptions-item label="催费回款金额后10名">
          <template slot="label">
            <span class="label-title">催费回款金额后10名</span>
          </template>
          <el-table
            :data="tableData.list4"
            :loading="loading"
            :row-class-name="rowClass"
            style="width: 100%">
            <el-table-column
              prop="战区名称"
              label="战区名称"
              width="100">
            </el-table-column>
            <el-table-column
              prop="片区名称"
              label="片区名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="项目名称"
              label="项目名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="职位"
              label="职位"
              width="100">
            </el-table-column>
            <el-table-column
              prop="管家名称"
              label="催费人员"
              width="120">
            </el-table-column>
            <el-table-column
              prop="催费金额"
              label="催费金额(元)">
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </el-col>
  </el-row>
</div>
</template>

<script>
import ButlerHttp from "../common/ButlerHttp";

export default {
  name: "LegalRanking",
  props:{
    typeId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    regionId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    projectId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    areaId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    projectIds:{
      type:Array|String,
      default(){
        return "";
      }
    },
    start_time:{
      type:Number|String,
      default(){
        return "";
      }
    },
    end_time:{
      type:Number|String,
      default(){
        return "";
      }
    }
  },
  data(){
    return{
      loading:false,
      tableData:{
        list1:[],
        list2:[],
        list3:[],
        list4:[],
      },
      group_id:"",
    }
  },
  watch:{
    projectIds:{
      deep:true,
      immediate:true,
      handler(){
        this.getList()
      }
    },
    projectId(n,o){
      this.getList()
    },
    start_time(n,o){
      this.getList()
    },
    end_time(n,o){
      this.getList()
    },
  },
  mounted() {
    this.getList();
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        project_ids:that.projectIds,
        project_id:that.projectId,
        area_id:that.areaId,
        start_time:that.start_time,
        end_time:that.end_time,
        group:that.group_id,
      }

      ButlerHttp.post("Legal/getLegalRanking", where, res => {
        if (res.code) {
          that.tableData = res.data;
        }
        that.loading = false;
      });
    },
    rowClass({row, rowIndex}){
      if(rowIndex<3){
        return 'red-row';
      }else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  .label-title{
    font-weight: bold;
    color: #487df8;
    font-size: 14px;
  }
  >>>.red-row{
    //background-color: #ff0000;
    font-weight: bold;
    color: #487df8;
    &:hover{
      //background-color: #ff0000 !important;
      color: black;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/LegalRanking.vue